export default __webpack_public_path__ + "7803a59f9a9717604369fa3b7bb5eef2.woff2";